import { Chat, ChatMessage } from '../../types/chat'
import { CreateChatMessageBody } from '../../types/messages'
import bikekeyApi, { CHATS, CHAT_UPDATES, TagAbstractIds } from './bikekeyApi'

interface GetChatsResponse {
    chats: Chat[]
}

interface GetChatMessagesResponse {
    chat_data: {
        messages: ChatMessage[]
        chat_meta: Partial<Chat>
    }
}

// Define a service using a base URL and expected endpoints
export const chatsApi = bikekeyApi.injectEndpoints({
    endpoints: (builder) => ({
        getChats: builder.query<GetChatsResponse, string>({
            query: () => ({
                url: `/chats/`,
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [{ type: CHATS, id: TagAbstractIds.LIST }],
        }),
        getChatMessages: builder.query<GetChatMessagesResponse, string>({
            query: (chatId: string) => ({
                url: `/chats/${chatId}/messages`,
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [{ type: CHAT_UPDATES, id: arg }],
        }),
        sendChatMessages: builder.mutation({
            query: ({ chatId, body }: { chatId: string; body: CreateChatMessageBody }) => ({
                url: `/chats/${chatId}/messages`,
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, arg) => [{ type: CHAT_UPDATES, id: arg.chatId }],
        }),
        newChat: builder.mutation<{ chat_id: string }, { body: CreateChatMessageBody }>({
            query: ({ body }: { body: CreateChatMessageBody }) => ({
                url: `/chats/`,
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, arg) => [{ type: CHATS, id: TagAbstractIds.LIST }],
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetChatsQuery,
    useGetChatMessagesQuery,
    useSendChatMessagesMutation,
    useNewChatMutation,
} = chatsApi
